import React from "react";
import { OrderStatus } from "../../../../types/OrderStatus";
import { BasicNotificationBanner } from "../../../BasicNotificationBanner";
import { Span } from "../../../Span";

interface Props {
  orderStatus: OrderStatus;
}

export const StatusInfoMessage: React.FC<Props> = ({ orderStatus }) => {
  const { infoMessage } = orderStatus;

  return (
    <>
      {infoMessage && (
        <BasicNotificationBanner
          message={() => (
            <Span dangerouslySetInnerHTML={{ __html: infoMessage }} />
          )}
          variant="default"
          icon="info"
          mb={1}
          mt={5}
          data-testid="info-message"
        />
      )}
    </>
  );
};
